import React, { useCallback, createContext, useContext, memo, useEffect } from 'react';
import util from '../../util';
import BreadcrumbsComponent from '../../components/common/BreadCrumb';
import { useSetState, useUniqueEffect } from '../../hooks';

const initialContextState = {
	actions: [],
	docTitle: null,
	hideHelp: false,
	breadcrumbs: [],
	subbreadcrumbs: [],
	infoMessage: {},
	hide: false
};
export const BreadcrumbsContext = createContext([
	[initialContextState, () => { }]
]);
export const useBreadcrumbs = (initialState = initialContextState) => {
	const [values, setValues] = useContext(BreadcrumbsContext);

	const setContextValues = useCallback((newValues) => {
		setValues((prev) => ({ ...prev, ...newValues }));
	}, []);
	useEffect(() => {
		if (typeof initialState === 'object' && !util.deepEqual(values, initialState)) {
			setContextValues({ ...initialState });
		}
	}, []);
	return [values, setContextValues];
};

export const BreadcrumbsProvider = memo(({ children }) => {
	const [state, setState] = useSetState({
		hide: false,
		docTitle: null,
		title: null,
		hideHelp: false,
		breadcrumbs: [],
		actions: [],
		subbreadcrumbs: [],
		infoMessage: {}
	}
	);
	return <BreadcrumbsContext value={[state, setState]}>{children}</BreadcrumbsContext>;
});

export const Breadcrumbs = () => {
	const [values, setValues] = useBreadcrumbs();
	return <BreadcrumbsComponent {...values} setContextValues={setValues} />;
};
export default BreadcrumbsProvider